import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { customError } from '@woulsl/sentry-config';
import bridge, { hasAppApi } from '@/utils/bridge';
var SIGN_BRIDGE_METHOD = 'generateRiskSignature';
var HEX_CHARS = '0123456789abcdef'; // 模块级缓存：Bridge 能力探测结果，页面生命周期内只探测一次

var hasApiCache = null;
/**
 * 探测并缓存签名 Bridge 能力
 * 探测异常视为不可用（放行），并上报 Sentry
 */

var checkSignApiAvailable = function checkSignApiAvailable() {
  if (!hasApiCache) {
    hasApiCache = hasAppApi(SIGN_BRIDGE_METHOD).catch(function (e) {
      customError({
        name: '防刷签名能力探测异常',
        message: (e === null || e === void 0 ? void 0 : e.message) || 'hasApi 探测失败',
        stack: e === null || e === void 0 ? void 0 : e.stack
      });
      return false;
    });
  }

  return hasApiCache;
};
/**
 * 生成 16 位随机小写 hex nonce
 * 优先使用 crypto.getRandomValues，不可用或异常时降级 Math.random
 */


var generateNonce = function generateNonce() {
  var result = '';

  try {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      var bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);

      for (var i = 0; i < bytes.length; i += 1) {
        result += HEX_CHARS[bytes[i] % 16];
      }

      return result;
    }
  } catch (e) {// 降级到 Math.random
  }

  for (var i = 0; i < 16; i += 1) {
    result += HEX_CHARS[Math.floor(Math.random() * 16)];
  }

  return result;
};
/**
 * 获取并缓存游客设备匿名标识
 * 优先读 __store.jojoDeviceInfo，未命中则调用 getDeviceInfo 并回填缓存
 */


var getAnonymousIdentifier = function getAnonymousIdentifier() {
  return __awaiter(void 0, void 0, void 0, function () {
    var cached, res, deviceInfo;

    var _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          cached = (_a = __store === null || __store === void 0 ? void 0 : __store.jojoDeviceInfo) === null || _a === void 0 ? void 0 : _a.anonymousIdentifier;

          if (cached) {
            return [2
            /*return*/
            , cached];
          }

          return [4
          /*yield*/
          , bridge.call('getDeviceInfo')];

        case 1:
          res = _b.sent();
          deviceInfo = res === null || res === void 0 ? void 0 : res.data;

          if (window.__store && deviceInfo) {
            __store.jojoDeviceInfo = deviceInfo;
          }

          return [2
          /*return*/
          , (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.anonymousIdentifier) || ''];
      }
    });
  });
};
/**
 * 生成防刷签名参数
 * 在调用 v2/purchases 系列接口前调用：组装通用参数 + 业务参数，经 Bridge 生成 riskVersion/riskToken
 * @param bizParams 接口业务参数（key/value 均会字符串化；无业务参数时传 {}）
 * @returns signed=携带签名参数透传；unsupported=Bridge 不可用放行；failed=签名失败阻断
 */


export var signRiskParams = function signRiskParams(bizParams) {
  return __awaiter(void 0, void 0, void 0, function () {
    var available, anonymousIdentifier, signParams_1, res, riskVersion, riskToken, e_1, err;

    var _a, _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4
          /*yield*/
          , checkSignApiAvailable()];

        case 1:
          available = _c.sent();

          if (!available) {
            return [2
            /*return*/
            , {
              status: 'unsupported'
            }];
          }

          _c.label = 2;

        case 2:
          _c.trys.push([2, 5,, 6]);

          return [4
          /*yield*/
          , getAnonymousIdentifier()];

        case 3:
          anonymousIdentifier = _c.sent();

          if (!anonymousIdentifier) {
            customError({
              name: '防刷签名失败',
              message: '获取 anonymousIdentifier 失败'
            });
            return [2
            /*return*/
            , {
              status: 'failed'
            }];
          }

          signParams_1 = {
            anonymousIdentifier: anonymousIdentifier,
            timestamp: String(Date.now()),
            nonce: generateNonce()
          };
          Object.keys(bizParams).forEach(function (key) {
            var value = bizParams[key];

            if (key && value !== undefined && value !== null && value !== '') {
              signParams_1[key] = String(value);
            }
          });
          return [4
          /*yield*/
          , bridge.call(SIGN_BRIDGE_METHOD, {
            params: signParams_1
          })];

        case 4:
          res = _c.sent();
          riskVersion = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.riskVersion;
          riskToken = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.riskToken; // 5. 校验返回完整性

          if ((res === null || res === void 0 ? void 0 : res.status) !== 200 || typeof riskVersion !== 'number' || !riskToken) {
            customError({
              name: '防刷签名失败',
              message: 'Bridge 返回非法或缺少 riskVersion/riskToken',
              captureContext: {
                extra: {
                  status: res === null || res === void 0 ? void 0 : res.status,
                  riskVersion: riskVersion,
                  riskToken: riskToken
                }
              }
            });
            return [2
            /*return*/
            , {
              status: 'failed'
            }];
          } // 6. 成功：原始签名参数 + riskVersion + riskToken


          return [2
          /*return*/
          , {
            status: 'signed',
            signedParams: {
              timestamp: signParams_1.timestamp,
              nonce: signParams_1.nonce,
              riskVersion: riskVersion,
              riskToken: riskToken
            }
          }];

        case 5:
          e_1 = _c.sent();
          err = e_1;
          customError({
            name: '防刷签名失败',
            message: (err === null || err === void 0 ? void 0 : err.message) || '签名流程异常',
            stack: err === null || err === void 0 ? void 0 : err.stack
          });
          return [2
          /*return*/
          , {
            status: 'failed'
          }];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
};